var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H8.828A8.828 8.828 0 0 0 0 97.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V97.103a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.495 421.751l283.868-160.268c4.268-2.41 4.268-8.556 0-10.965L3.495 90.249C1.42 91.864 0 94.271 0 97.103v317.793c0 2.833 1.421 5.24 3.495 6.855z",
    fill: "#ffe15a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.741 421.244l192.932-159.171c3.817-3.149 3.817-8.996 0-12.146L2.741 90.756C1.065 92.364 0 94.598 0 97.103v317.793c0 2.506 1.065 4.741 2.741 6.348z",
    fill: "#464655"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.132 214.545l.841 31.772-29.789 11.081c-2.857 1.063-2.717 5.15.206 6.015l30.477 9.018 1.334 31.755c.128 3.046 4.058 4.175 5.784 1.663L81.98 279.65l30.613 8.544c2.935.82 5.225-2.57 3.369-4.987l-19.357-25.21 17.586-26.474c1.686-2.539-.829-5.763-3.702-4.745l-29.956 10.618-19.744-24.906c-1.895-2.389-5.738-.992-5.657 2.055z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl);
export default __webpack_public_path__ + "static/media/tl.8c31c68bd5617da57915047570a8647f.svg";
export { ForwardRef as ReactComponent };